import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Helmet } from "react-helmet";

const Services = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant company</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=""
                />
                <meta
                    name="keywords"
                    content=""
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Professional Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src="https://assets.bacancytechnology.com/main-boot-5/images/sales-inti-org/banner-1.jpg?v-1" alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <div class="right-section-service">
                            <div class="bookmarks-wrapper" aria-labelledby="icp_toc_title">
                                <div className='right-section-heading'>
                                    <h3>Table of contents</h3>
                                </div>
                                <div class="bookmark-items">
                                    <div class="bookmark-item " data-item="1" data-config="">
                                        <div class="bookmark-item-content">
                                            <div class="bookmark-item-offset level-0">
                                            </div>
                                            <div class="bookmark-item-text">
                                                <p><a href="#why-codezix" class="active current">Why Codezix</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bookmark-item " data-item="2" data-config="">
                                        <div class="bookmark-item-content">
                                            <div class="bookmark-item-offset level-0">
                                            </div>
                                            <div class="bookmark-item-text">
                                                <p><a href="#capabilities" class="">Customers Say</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bookmark-item " data-item="4" data-config="">
                                        <div class="bookmark-item-content">
                                            <div class="bookmark-item-offset level-0">
                                            </div>
                                            <div class="bookmark-item-text">
                                                <p><a href="#services" class="">Our Services</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bookmark-item " data-item="3" data-config="">
                                        <div class="bookmark-item-content">
                                            <div class="bookmark-item-offset level-0">
                                            </div>
                                            <div class="bookmark-item-text">
                                                <p><a href="#selected-blog" class=""> Projects</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bookmark-item " data-item="5" data-config="">
                                        <div class="bookmark-item-content">
                                            <div class="bookmark-item-offset level-0">
                                            </div>
                                            <div class="bookmark-item-text">
                                                <p><a href="#Implementation" class="">Products we work with</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service bottom">
                            <p className="prose-lg wow fadeUp">Salesforce professional services include consulting, implementation, support, and other solutions designed to unlock the full potential of Salesforce for your business.</p>
                            <p className="prose-lg wow fadeUp">Codezixoffers a comprehensive range of Salesforce professional services to assist businesses in enhancing their sales, marketing, and customer service operations.</p>
                            <div className="row mt-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Want to Maximize Your Salesforce Value?</h3>
                                        <p className="prose-lg wow fadeUp">If you’re looking to make the most of your Salesforce solution, check what prevents it
                                            from working to the full. Codezixexperts are ready to audit your Salesforce CRM,
                                            spotting inefficient processes, duplicate records, and other faults to help you leverage your Salesforce potential.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Get Salesforce</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix" id="why-codezix">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezixis a 3-time Champion in the Financial Times' Americas’ Fastest-Growing Companies Rating. </li>
                                    <li className="wow fadeUp prose-lg">10 years in IT business. </li>
                                    <li className="wow fadeUp prose-lg">10 years in CRM development. </li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board. </li>
                                    <li className="wow fadeUp prose-lg">At Codezix, our top priority is achieving project goals despite time, budget constraints, and evolving requirements. You set the goals, and we drive the project to successfully meet them. </li>
                                    <li className="wow fadeUp prose-lg">Codezixhas industry expertise across various sectors, including manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                    <li className="wow fadeUp prose-lg">With 10+ years of experience in software development and consulting, Codezixbrings multi-disciplinary expertise in areas such as IoT, big data, data science, collaboration solutions, mobile app development, and image analysis, tackling complex projects that extend beyond Salesforce.</li>
                                </ul>
                            </div>
                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className='achieve-project mb-4'>
                            <button className="prose-md">What makes Codezix different</button>
                            <h3>We achieve project success no matter what</h3>
                            <p>At Codezix, we distinguish between project administration and true project management—a distinction often overlooked in the industry. We prioritize effective, hands-on project management to ensure successful outcomes for our clients, no matter the challenges that may arise.</p>
                            <Link to="/"> <button>See how we do it&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                        </div>

                        <div className="salesforce-services mt-4" id="services">
                            <div className='explore-heading text-left'>
                                <h2>Our Salesforce Services</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezixoffers a comprehensive range of Salesforce professional services to enhance your CRM strategy with the right software solution.</p>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/services/consulting/consulting.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce consulting</h3>
                                            <p className="wow fadeUp prose-lg">Count on our experienced consultants to address your unique CRM challenges, from low sales productivity and poor departmental alignment to CRM performance issues. Our experts will also provide training to empower your team to fully leverage the potential of Salesforce.</p>
                                            <Link to="/consulting"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/services/consulting/implementation.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce implementation</h3>
                                            <p className="wow fadeUp prose-lg">Our team is prepared to handle your Salesforce implementation, delivering a reliable solution tailored to your needs. From implementation consulting to post-launch support, we focus on creating a solution that effectively meets your business requirements.</p>
                                            <Link to="/implementation"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/services/consulting/customization.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce customization</h3>
                                            <p className="wow fadeUp prose-lg">Receive a solution tailored to your industry's specific needs and business goals. Unlock the full potential of the Salesforce platform with customized modules for sales and marketing automation, lead and opportunity management, performance tracking, reporting, and more.</p>
                                            <Link to="/customization"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/services/consulting/development.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce application development</h3>
                                            <p className="wow fadeUp prose-lg">Get a custom Salesforce application that goes beyond the default functionality to enhance your sales, marketing, and customer service processes. Alternatively, choose an AppExchange app to drive revenue or an app to seamlessly integrate your software product with Salesforce.</p>
                                            <Link to="/development"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/services-icons/migration.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce migration</h3>
                                            <p className="wow fadeUp prose-lg">Safely migrate to Salesforce from your legacy system, on-premises or cloud hosted. Our team will help to securely transfer all customer data, minimize work disruptions and speed up user adoption. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/services-icons/integration.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce integration</h3>
                                            <p className="wow fadeUp prose-lg">Ensure a seamless information flow between departments and get full customer data consistency by connecting Salesforce to other corporate software run on the premises or hosted in the cloud. We are ready to take up complex projects regarding Salesforce integration with ERP, CRM, accounting, marketing automation, and other systems.</p>
                                            <Link to="/integration"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/services-icons/upgrade.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce upgrade</h3>
                                            <p className="wow fadeUp prose-lg">As long as your business grows, extend the platform’s functionality, get custom add-ons and incorporate technical advances into your Salesforce to stay ahead of the competition.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/services/consulting/support.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce support</h3>
                                            <p className="wow fadeUp prose-lg">Ensure long-term stability of your Salesforce. Just choose a convenient package to anticipate and promptly resolve performance issues, minimize system downtimes, and improve user adoption.</p>
                                            <Link to="/salesforce/support"><button>Learn More</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product">
                                <div className='explore-heading text-left'>
                                    <h2>Our Salesforce Services</h2>
                                    <p className="wow fadeUp prose-lg text-left">Codezixoffers a comprehensive range of Salesforce professional services to enhance your CRM strategy with the right software solution.</p>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/sales-cloud">
                                                <h3 class="mt-0">Sales Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/service-cloud">
                                                <h3 class="mt-0">Service Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/marketing-cloud">
                                                <h3 class="mt-0">Marketing Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/community-cloud">
                                                <h3 class="mt-0">Community Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/finencial-service-cloud">
                                                <h3 class="mt-0">Financial Services Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/non-profit">
                                                <h3 class="mt-0">Nonprofit Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/cpq">
                                                <h3 class="mt-0">Salesforce CPQ</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/customization#">
                                                <h3 class="mt-0">Salesforce Chatter</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-shadow">
                                <div className="row mt-4 mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Get in touch</h3>
                                            <p className="prose-lg wow fadeUp">Ready to transform your Salesforce solution into a powerful tool for building lasting customer relationships? Reach out to our consultants to determine the Salesforce services that best suit your needs.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button> Contact </button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </>
    )
}

export default Services;